export default "__VITE_ASSET__e79d239c__"